import { useTranslation } from "react-i18next";

const WINDOW_SIZE = 5;

const PageSwitcher = ({ currentPage, totalPages, activitiesAmount, handlePageClick }) => {
    const { t } = useTranslation();

    // Finestra di 5 numeri centrata sulla pagina corrente, clampata ai bordi.
    const half = Math.floor(WINDOW_SIZE / 2);
    const maxStart = Math.max(1, totalPages - WINDOW_SIZE + 1);
    const start = Math.min(Math.max(1, currentPage - half), maxStart);
    const end = Math.min(totalPages, start + WINDOW_SIZE - 1);
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);

    const isFirst = currentPage === 1;
    const isLast = currentPage === totalPages;

    const arrowBase = "w-[40px] h-[50px] flex justify-center items-center text-xl";
    const arrowEnabled = "cursor-pointer text-[#225424]";
    const arrowDisabled = "text-slate-300 cursor-not-allowed";

    return (
        <div className="w-full flex gap-2 justify-center items-center my-8">
            <div className="flex flex-col gap-2">

                <div className="flex justify-center text-slate-400">
                    {t('AllActivities.PageSwitcher.totalPages')} {totalPages}
                </div>

                <div className="flex gap-2">
                    {/* DOUBLE LEFT — prima pagina */}
                    <div
                        className={`${arrowBase} pb-1.5 ${isFirst ? arrowDisabled : arrowEnabled}`}
                        onClick={() => !isFirst && handlePageClick(1)}
                    >
                        <i className="fi fi-br-angle-double-right rotate-180"></i>
                    </div>

                    {/* SINGLE LEFT — pagina precedente */}
                    <div
                        className={`${arrowBase} pb-1.5 ${isFirst ? arrowDisabled : arrowEnabled}`}
                        onClick={() => !isFirst && handlePageClick(currentPage - 1)}
                    >
                        <i className="fi fi-br-angle-right rotate-180"></i>
                    </div>

                    {/* FINESTRA NUMERI — desktop: 5 numeri; mobile (<md): solo corrente */}
                    {pages.map((p) => {
                        const isCurrent = p === currentPage;
                        const visibility = isCurrent ? 'flex' : 'hidden md:flex';
                        return (
                            <div
                                key={p}
                                className={`w-[40px] h-[50px] ${visibility} justify-center items-center p-3 rounded ${isCurrent ? 'text-slate-400' : 'border cursor-pointer'}`}
                                onClick={() => !isCurrent && handlePageClick(p)}
                            >
                                {p}
                            </div>
                        );
                    })}

                    {/* SINGLE RIGHT — pagina successiva */}
                    <div
                        className={`${arrowBase} pt-1.5 ${isLast ? arrowDisabled : arrowEnabled}`}
                        onClick={() => !isLast && handlePageClick(currentPage + 1)}
                    >
                        <i className="fi fi-br-angle-right"></i>
                    </div>

                    {/* DOUBLE RIGHT — ultima pagina */}
                    <div
                        className={`${arrowBase} pt-1.5 ${isLast ? arrowDisabled : arrowEnabled}`}
                        onClick={() => !isLast && handlePageClick(totalPages)}
                    >
                        <i className="fi fi-br-angle-double-right"></i>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default PageSwitcher;
